import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import ServicesSection from "./sections/ServicesSection";
import WhyChooseUsSection from "./sections/WhyChooseUsSection";
import ProcessSection from "./sections/ProcessSection";
import StatsSection from "./sections/StatsSection";
import PortfolioSection from "./sections/PortfolioSection";
import ContactConsultationSection from "./sections/ContactConsultationSection";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroSection />
      <ServicesSection />
      <WhyChooseUsSection />
      <ProcessSection />
      <StatsSection />
      <PortfolioSection />
      <ContactConsultationSection />
      <Footer />
    </div>;
}